import React from 'react';

import './Footer.css';

const Footer = function Footer() {
  return (
    <footer className="Footer_footer__wQhn8">
      <div className="Newsletter_container__NuYGd">
        <div className="Newsletter_block__Ggxa5" data-is-b2b="false">
          <img
            alt=""
            src="https://www.manomano.co.uk/assets/img/themes/default/svg/newsletter/newsletter-b2c.svg"
            className="Newsletter_illustration__68X5H"
            height="135"
            width="142"
          />
          <div className="Newsletter_inputBlock__K_C_K">
            <span className="Newsletter_title__6Xoey">Newsletter</span>
            <span className="Newsletter_subTitle__iw4LX">
              Receive exclusive offers before anyone else!
            </span>
            <form className="Newsletter_form__UKfpk" id="newsletter-form">
              <div className="container_90f49d77">
                <div className="content_90f49d77">
                  <div className="wrapper_90f49d77">
                    <label
                      htmlFor="footerNewsletterEmailInput"
                      className="label_90f49d77"
                    >
                      Enter your email address here *
                      <input
                        id="footerNewsletterEmailInput"
                        aria-invalid="false"
                        className="input_90f49d77"
                        name="email"
                        value=""
                      />
                    </label>
                  </div>
                  <button
                    tabIndex="-1"
                    className="NewsletterButton_submitButton__ZXCvA button_e79faaed themeDefault_e79faaed variantPrimary_e79faaed"
                    type="submit"
                  >
                    <span>Sign Up</span>
                  </button>
                </div>
              </div>
            </form>
            <span className="Newsletter_subText__wOgNk">
              Promise, we will only use your email address to send you our
              newsletters (deals, promotions, etc.). Rest assured, you can
              unsubscribe at any time using the link in the newsletter if it
              gets too much!
              <span className="linkListItemDefaultLight_c5185a9e linkListItem_c5185a9e Newsletter_subTextLink__clkAw">
                <a tabIndex="0" target="_blank" href="/data-protection">
                  &nbsp;Click for more information about data handling and your
                  rights in relation to your data.
                </a>
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="Footer_grid__9_kTY">
        <div className="Footer_other__u7W1m Footer_column__h_D53">
          <span className="Payment_titleBlock__cbr6_">
            <svg
              aria-hidden="true"
              focusable="false"
              height="1em"
              role="presentation"
              width="1em"
              viewBox="0 0 24 24"
              className="svg_9c8206b6 Payment_lock__OBtKO"
            >
              <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
            </svg>
            <span className="Payment_title__VNbo_">Secure payment</span>
          </span>
          <div className="Payment_container__GNIvz">
            <img
              alt="Visa"
              src="https://www.manomano.co.uk/assets/img/themes/default/svg/payment/Visa.svg"
              height="32"
              width="48"
            />
            <img
              alt="Mastercard"
              src="https://www.manomano.co.uk/assets/img/themes/default/svg/payment/Mastercard.svg"
              height="32"
              width="48"
            />
            <img
              alt="Paypal"
              src="https://www.manomano.co.uk/assets/img/themes/default/svg/payment/Paypal.svg"
              height="32"
              width="48"
            />
            <img
              alt="Virement"
              src="https://www.manomano.co.uk/assets/img/themes/default/svg/payment/Virement.svg"
              height="32"
              width="48"
            />
          </div>
          <div className="SocialMedia_container__BpEQf">
            <button
              className="Accordion_container__Jn8ZY"
              type="button"
              aria-expanded="false"
            >
              <span className="Accordion_text__0uC7Y">
                <span className="Accordion_title__Q0z84">
                  Join the conversation!
                </span>
                <span className="Accordion_subTitle__Mk9t5">
                  The magic of the Internet, across the globe!
                </span>
              </span>
            </button>
            <div
              className="Accordion_block__ZwB2V"
              data-expanded="false"
              data-is-expandable="false"
            >
              <div className="SocialMedia_links__sfY9X">
                <a
                  className="SocialMedia_link__eKOj5"
                  href="https://twitter.com/ManoMano_UK"
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label="Twitter"
                  data-testid="contactTwitterCta"
                >
                  <img
                    alt="Twitter"
                    src="https://www.manomano.co.uk/assets/img/themes/default/svg/social-media/sprites/twitter.svg"
                    className="SocialMedia_linkIcon__95mkL"
                    title="Twitter"
                    width="40"
                    height="100"
                  />
                </a>
                <a
                  className="SocialMedia_link__eKOj5"
                  href="https://www.facebook.com/manomanoUK/"
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label="Facebook"
                  data-testid="contactFacebookCta"
                >
                  <img
                    alt="Facebook"
                    src="https://www.manomano.co.uk/assets/img/themes/default/svg/social-media/sprites/facebook.svg"
                    className="SocialMedia_linkIcon__95mkL"
                    title="Facebook"
                    width="40"
                    height="100"
                  />
                </a>
                <a
                  className="SocialMedia_link__eKOj5"
                  href="https://uk.pinterest.com/ManoManoUK/"
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label="Pinterest"
                  data-testid="contactPinterestCta"
                >
                  <img
                    alt="Pinterest"
                    src="https://www.manomano.co.uk/assets/img/themes/default/svg/social-media/sprites/pinterest.svg"
                    className="SocialMedia_linkIcon__95mkL"
                    title="Pinterest"
                    width="40"
                    height="100"
                  />
                </a>
                <a
                  className="SocialMedia_link__eKOj5"
                  href="https://blog.manomano.co.uk/"
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label="Blogger"
                  data-testid="contactBloggerCta"
                >
                  <img
                    alt="Blogger"
                    src="https://www.manomano.co.uk/assets/img/themes/default/svg/social-media/sprites/blog.svg"
                    className="SocialMedia_linkIcon__95mkL"
                    title="Blogger"
                    width="40"
                    height="100"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="Footer_contact__oL_Pn Footer_column__h_D53">
          <div className="Navigation_container__LfndM">
            <button
              className="Accordion_container__Jn8ZY"
              type="button"
              aria-expanded="false"
            >
              <span className="Accordion_text__0uC7Y">
                <span className="Accordion_title__Q0z84">
                  Information &amp; Contact
                </span>
                <span className="Accordion_subTitle__Mk9t5">
                  Every which way but fax!
                </span>
              </span>
              <svg
                aria-hidden="true"
                focusable="false"
                height="1em"
                role="presentation"
                width="1em"
                viewBox="0 0 24 24"
                className="svg_9c8206b6 Accordion_expander__GJaDZ"
              >
                <path
                  d="M8.12 9.29L12 13.17l3.88-3.88a.996.996 0 111.41 1.41l-4.59 4.59a.996.996 0 01-1.41 0L6.7 10.7a.996.996 0 010-1.41c.39-.38 1.03-.39 1.42 0z"
                  fill="currentColor"
                />
              </svg>
            </button>
            <div
              className="Accordion_block__ZwB2V"
              data-expanded="false"
              data-is-expandable="true"
            >
              <ul className="linkList_db6703e6">
                <li
                  className="linkListItemDefaultDark_c5185a9e linkListItem_c5185a9e"
                  style={{ padding: '4px 0px' }}
                >
                  <a tabIndex="0" href="/contact" data-testid="contactCta">
                    Contact &amp; FAQ
                  </a>
                </li>
                <li
                  className="linkListItemDefaultDark_c5185a9e linkListItem_c5185a9e"
                  style={{ padding: '4px 0px' }}
                >
                  <a tabIndex="0" href="/orders" data-testid="accountOrderCta">
                    Track orders
                  </a>
                </li>
                <li
                  className="linkListItemDefaultDark_c5185a9e linkListItem_c5185a9e"
                  style={{ padding: '4px 0px' }}
                >
                  <a
                    tabIndex="0"
                    href="https://about.manomano.com/en"
                    data-testid="aboutUsCta"
                  >
                    Who are we?
                  </a>
                </li>
                <li
                  className="linkListItemDefaultDark_c5185a9e linkListItem_c5185a9e"
                  style={{ padding: '4px 0px' }}
                >
                  <a
                    tabIndex="0"
                    href="/recruiting-seller"
                    data-testid="recruitingSellerCta"
                  >
                    Become a seller
                  </a>
                </li>
                <li
                  className="linkListItemDefaultDark_c5185a9e linkListItem_c5185a9e"
                  style={{ padding: '4px 0px' }}
                >
                  <a
                    tabIndex="0"
                    href="https://about.manomano.com/en/press"
                    data-testid="pressCta"
                  >
                    Press Enquiries
                  </a>
                </li>
                <li
                  className="linkListItemDefaultDark_c5185a9e linkListItem_c5185a9e"
                  style={{ padding: '4px 0px' }}
                >
                  <a
                    tabIndex="0"
                    href="https://jobs.manomano.com/en"
                    data-testid="recruitingCta"
                    rel="noopener"
                  >
                    Join Us
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="Footer_about__Gbsxm Footer_column__h_D53">
          <div className="About_container__XArP9">
            <button
              className="Accordion_container__Jn8ZY"
              type="button"
              aria-expanded="false"
            >
              <span className="Accordion_text__0uC7Y">
                <span className="Accordion_title__Q0z84">Find Out More</span>
                <span className="Accordion_subTitle__Mk9t5">
                  The Serious Bits
                </span>
              </span>
              <svg
                aria-hidden="true"
                focusable="false"
                height="1em"
                role="presentation"
                width="1em"
                viewBox="0 0 24 24"
                className="svg_9c8206b6 Accordion_expander__GJaDZ"
              >
                <path
                  d="M8.12 9.29L12 13.17l3.88-3.88a.996.996 0 111.41 1.41l-4.59 4.59a.996.996 0 01-1.41 0L6.7 10.7a.996.996 0 010-1.41c.39-.38 1.03-.39 1.42 0z"
                  fill="currentColor"
                />
              </svg>
            </button>
            <div
              className="Accordion_block__ZwB2V"
              data-expanded="false"
              data-is-expandable="true"
            >
              <ul className="linkList_db6703e6">
                <li
                  className="linkListItemDefaultDark_c5185a9e linkListItem_c5185a9e"
                  style={{ padding: '4px 0px' }}
                >
                  <a
                    tabIndex="0"
                    href="/our-advice"
                    data-testid="siteMapAdviceCta"
                  >
                    Our advice
                  </a>
                </li>
                <li
                  className="linkListItemDefaultDark_c5185a9e linkListItem_c5185a9e"
                  style={{ padding: '4px 0px' }}
                >
                  <a
                    tabIndex="0"
                    href="/the-most-popular-product-categories"
                    data-testid="siteMapMasslandingCta"
                  >
                    The most popular product categories
                  </a>
                </li>
                <li
                  className="linkListItemDefaultDark_c5185a9e linkListItem_c5185a9e"
                  style={{ padding: '4px 0px' }}
                >
                  <a
                    tabIndex="0"
                    href="/our-comparisons"
                    data-testid="siteMapTopProductsCta"
                  >
                    Our comparisons
                  </a>
                </li>
                <li
                  className="linkListItemDefaultDark_c5185a9e linkListItem_c5185a9e"
                  style={{ padding: '4px 0px' }}
                >
                  <a tabIndex="0" href="/brands" data-testid="brandListCta">
                    Our brands
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="International_container__dtyvA">
            <button
              className="Accordion_container__Jn8ZY"
              type="button"
              aria-expanded="false"
            >
              <span className="Accordion_text__0uC7Y">
                <span className="Accordion_title__Q0z84">International</span>
                <span className="Accordion_subTitle__Mk9t5">
                  Coming soon to planet Mars!
                </span>
              </span>
            </button>
            <div
              className="Accordion_block__ZwB2V"
              data-expanded="false"
              data-is-expandable="false"
            >
              <div className="Flags_group__tSmP0">
                <a
                  className="Flags_flag__ed2oj"
                  href="https://www.manomano.fr/"
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label="ManoMano FR"
                  data-testid="contactFlagFRCta"
                >
                  <img
                    alt="ManoMano FR"
                    src="https://www.manomano.co.uk/assets/img/themes/default/svg/flags/fr.svg"
                    width="32"
                    height="32"
                  />
                </a>
                <a
                  className="Flags_flag__ed2oj"
                  href="https://www.manomano.it/"
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label="ManoMano IT"
                  data-testid="contactFlagITCta"
                >
                  <img
                    alt="ManoMano IT"
                    src="https://www.manomano.co.uk/assets/img/themes/default/svg/flags/it.svg"
                    width="32"
                    height="32"
                  />
                </a>
                <a
                  className="Flags_flag__ed2oj"
                  href="https://www.manomano.de/"
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label="ManoMano DE"
                  data-testid="contactFlagDECta"
                >
                  <img
                    alt="ManoMano DE"
                    src="https://www.manomano.co.uk/assets/img/themes/default/svg/flags/de.svg"
                    width="32"
                    height="32"
                  />
                </a>
                <a
                  className="Flags_flag__ed2oj"
                  href="https://www.manomano.es/"
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label="ManoMano ES"
                  data-testid="contactFlagESCta"
                >
                  <img
                    alt="ManoMano ES"
                    src="https://www.manomano.co.uk/assets/img/themes/default/svg/flags/es.svg"
                    width="32"
                    height="32"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <button className="ToTopButton_container__TlAbG" type="button">
          <svg
            aria-hidden="true"
            focusable="false"
            height="1em"
            role="presentation"
            width="1em"
            viewBox="0 0 24 24"
            className="svg_9c8206b6 ToTopButton_arrow__46XTr"
          >
            <path
              d="M5.418 11h11.17l-4.88-4.88c-.39-.39-.39-1.03 0-1.42a.996.996 0 011.41 0l6.59 6.59c.39.39.39 1.02 0 1.41l-6.59 6.59a.996.996 0 11-1.41-1.41l4.88-4.88H5.417c-.55 0-1-.45-1-1s.45-1 1-1z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>
      <div className="Footer_legal__CRx6m">
        <span data-testid="copyrightElm" className="LegalData_copyright__vxe1_">
          ©2022 ManoMano
        </span>
        <span>
          <button type="button" className="LegalData_buttonLink__swQQu">
            Manage cookies
          </button>
        </span>
        <a
          data-testid="siteMapCta"
          className="LegalData_moreLinks__OTwrq"
          href="/sitemap"
        >
          Sitemap
        </a>
        <a
          target="_blank"
          data-testid="legalCta"
          rel="nofollow"
          className="LegalData_moreLinks__OTwrq"
          href="/legals"
        >
          Legal Notice
        </a>
        <a
          data-testid="dataProtectCta"
          rel="nofollow noreferrer"
          target="_blank"
          className="LegalData_moreLinks__OTwrq"
          href="/data-protection"
        >
          Data Protection Policy
        </a>
        <a
          data-testid="termsAndConditionsCta"
          rel="nofollow noreferrer"
          className="LegalData_moreLinks__OTwrq"
          target="_blank"
          href="/cgu"
        >
          Terms and conditions
        </a>
        <a
          target="_blank"
          data-testid="consumptionInformationCta"
          rel="nofollow"
          className="LegalData_moreLinks__OTwrq"
          href="/consumer-information"
        >
          consumer information
        </a>
      </div>
    </footer>
  );
};

export default Footer;
